const defaultEnv = {
  version: process.env.VERSION || '0.0.0',
  title: process.env.TITLE || 'Aetos AI',
  description: process.env.DESCRIPTION || 'Earth Observation Factory AI',
  home_page: process.env.HOME_PAGE || 'https://terravelox.id',

  auth_url: process.env.AUTH_URL || '',
  // php_url: process.env.PHP_URL || 'https://apiphp.eofactory.ai',
  echo_server: process.env.ECHO_SERVER || window.location.hostname,

  tripe_key: process.env.TRIPE_KEY || '',
  ssr_tile_url: process.env.SSR_TILE_URL || 'https://ssrtile.eofactory.ai',

  segment_anything_url: process.env.SEGMENT_ANYTHING_URL || '/aetos-ai/segment-anything',
  pixel_magic_url: process.env.TABLE_MAGIC_URL || '/aetos-ai/pixel-magic',
  table_magic_url: process.env.SEGMENT_ANYTHING_URL || '/aetos-ai/data-magic',
  stac_url: process.env.STAC_URL || '/aetos-cube/api/stac/v1',

  s3_companion_url: process.env.S3_COMPANION_URL || '/companion',
  auth_server: process.env.AUTH_URL || '',
  php_url: process.env.PHP_URL || '/aetos-ai/apiphp',
  app_path: process.env.APP_PATH || '/aetos-ai',
  catalog_url: process.env.CATALOG_URL || '/aetos-cube',
  wf_tile_url: process.env.WFTILE_URL ? process.env.WFTILE_URL.split(',') : ['/core-workflow-tile'],
  tile_raster_url: process.env.TILE_RASTER_URL || '/aetos-ai/tile/raster',

  domain: process.env.DOMAIN || '',
  tile_server: process.env.TILE_SERVER || window.location.origin + '/core-tile-server',
}
let env = defaultEnv
if (typeof window !== 'undefined' && window.__env__) {
  env = {
    ...defaultEnv,
    ...window.__env__
  }
}
export default env



// WEBPACK FOOTER //
// ./src/config.js